import { registerApi as api } from '../../api';

export const fetchEmp_SeparationData = async (current_month) => {
  try {
    const client_ID = sessionStorage.getItem('selectedClient')
    const response = await api.get(`/get_emp_separation/${current_month}`, {
      params: {
        client_id: client_ID
      }
    });    
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}
export const updateEmp_Separation = async (id, Emp_separationData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_emp_seration/${id}`, Emp_separationData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}
export const deleteEmp_Separation = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_emp_separation/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

// export const upload_Emp_separation = async (Emp_separationDataInput) => {
//   try {
//     const token = sessionStorage.getItem('token');
//     const selectedClientID = sessionStorage.getItem('selectedClient')
//     const response = await api.post('/upload_emp_separation', Emp_separationDataInput, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       },
//       params : {
//         'selectedClientID' : selectedClientID
//       }
//     });
//     return {
//       data: response,
//       status: response.status,
//     };
//   } catch (error) {
//     throw error.response.data.error;
//   }
// };


export const upload_Emp_separation = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient')
    const response = await api.post('/upload_emp_separation', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      params : {
        'selectedClientID' : selectedClientID
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};


export const multiDeleteEmp_Separation = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multiple_emp_separation', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
